import React from "react";
import PageHero from "@/components/PageHero";
import Section from "@/components/Section";
import { PRIVACY_HTML } from "@/constants/privacyContent";

export default function PrivacyPolicy() {
  return (
    <>
      <PageHero
        title="Privacy Policy"
        subtitle="v2.0 — Effective May 8, 2026. Read how HomeCure (by MESRON HEALTHCARE LLP) collects, stores, processes and shares personal data."
      />
      <Section>
        <div className="max-w-4xl mx-auto hc-prose" data-testid="privacy-content" dangerouslySetInnerHTML={{ __html: PRIVACY_HTML }} />
      </Section>
    </>
  );
}
